module.exports = __webpack_public_path__ + "static/media/Solicitudesdeinformacion.4f714f94.png";